/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var menu_dropdown_elements = document.querySelectorAll('.menu-item-has-children');
  if(menu_dropdown_elements) {
    check_dropdown_elements();

    window.addEventListener('resize', (e) => {
      check_dropdown_elements();
    });

    setInterval(check_dropdown_elements, 200);
  }

  function check_dropdown_elements() {
    menu_dropdown_elements.forEach((menu_dropdown_element) => {
      var dropdown = menu_dropdown_element.querySelector('.sub-menu-container'),
          rect = dropdown.getBoundingClientRect();

      if(dropdown) {
        if(rect.left < 0) {
          dropdown.classList.remove('attach-right');
          dropdown.classList.add('attach-left');
        }

        if((rect.left + dropdown.offsetWidth) > document.body.offsetWidth) {
          dropdown.classList.add('attach-right');
          dropdown.classList.remove('attach-left');
        }
      }
    });
  }
}());